import App from 'app/app.js';

var FailureTypeConstants = {
  SYSTEM_TIMEOUT: 'SYSTEM_TIMEOUT',
  INVALID_CARD_DETAILS: 'INVALID_CARD_DETAILS',
  INVALID_CARD_NUMBER: 'INVALID_CARD_NUMBER',
  INVALID_BILLING: 'INVALID_BILLING',
  CUSTOMER_ISSUE: 'CUSTOMER_ISSUE',
  UNKNOWN_FAILURE: 'UNKNOWN_FAILURE',
  PROCESSING_TIMEOUT: 'PROCESSING_TIMEOUT',
  DUPLICATE_TRANSACTION: 'DUPLICATE_TRANSACTION',
  FALLBACK_FAILURE: 'FALLBACK_FAILURE',
  UNSUPPORTED_CARD_TYPE: 'UNSUPPORTED_CARD_TYPE'
};

App.constant('FailureTypeConstants', FailureTypeConstants);
